import { useQueryWithUserId } from '@northladder/services';

import { AUTO_ASSESSMENTS_API } from '../autoAssessmentsAPIClient';

export const AUTO_ASSESSMENT_REQUEST_DETAILS_QUERY_KEY =
  'auto-assessment-request-details-key';

type IAutoAssessmentRequestDetailsQueryProps = {
  identifier?: string;
  sessionId: string;
};

/**
 * Custom query hook to fetch the auto assessment request details with respective
 * `sessionId`.
 */
export function useAutoAssessmentsRequestsDetailsQuery(
  queryParams: IAutoAssessmentRequestDetailsQueryProps
) {
  const { sessionId, identifier } = queryParams;

  const { data, isPending, isFetching, isError, error, refetch } =
    useQueryWithUserId({
      queryKey: [
        AUTO_ASSESSMENT_REQUEST_DETAILS_QUERY_KEY,
        sessionId,
        identifier,
      ],
      enabled: !!sessionId,
      networkMode: 'always',
      retry: false,
      queryFn: () =>
        AUTO_ASSESSMENTS_API.fetchAssessmentRequestDetails(
          sessionId,
          identifier
        ),
    });

  return {
    data,
    error,
    isError,
    isFetching,
    isPending,
    refetch,
  };
}
